import { Injectable } from "@angular/core";

import { CacheService } from "./cache.service";
import { environment } from "@apps/patient-core/src/app/environments/environment";
import { isRootDomain } from "../utils";

const HOSTNAME_STORAGE_KEY = "hostname";
const ACTUAL_HOSTNAME_STORAGE_KEY = "actual-hostname";
const { HOST_ZONE } = environment;

@Injectable({
  providedIn: "root",
})
export class LocationService {
  private _hostname;
  private _actualHostname;

  constructor(private _cacheService: CacheService) {
    try {
      this._hostname = this._cacheService.getSession(HOSTNAME_STORAGE_KEY);
      this._actualHostname = this._cacheService.getSession(ACTUAL_HOSTNAME_STORAGE_KEY);
    } catch {}
  }

  public get hostname(): string {
    return this._hostname || window.location.hostname;
  }

  public set hostname(hostname: string) {
    this._hostname = hostname;

    this._cacheService.setSession(HOSTNAME_STORAGE_KEY, hostname);
  }

  public set actualHostname(hostname: string) {
    this._actualHostname = hostname;

    this._cacheService.setSession(ACTUAL_HOSTNAME_STORAGE_KEY, hostname);
  }

  /**
   * Gets the actual hostname of the current window. Use hostname to get the relative hostname (used to make global domains work)
   */
  public get actualHostname(): string {
    return this._actualHostname || window.location.hostname;
  }

  public get pathname(): string {
    return window.location.pathname;
  }

  public set href(href: string) {
    window.location.href = href;
  }

  private get _stage(): string {
    return environment.STAGE;
  }

  public get isPreferencesDomain(): boolean {
    const regex = new RegExp(`^preferences\.(${this._stage}\.)?${HOST_ZONE}$`);

    return regex.test(this.actualHostname);
  }

  public get isRootDomain(): boolean {
    return isRootDomain(this._stage);
  }

  public get search(): Record<string, string> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = new URLSearchParams(window.location.search) as any;

    return Object.fromEntries([...params]) as Record<string, string>;
  }
}
